export default __webpack_public_path__ + "static/media/lprDots.89f21f04.png";